import { camelizeKeys } from 'humps';
import { ApiError } from '@rambler-id/errors';
import { request } from './transport';
export const geoApi = async (endpoint) => {
    let json;
    try {
        const response = await request(`//id.rambler.ru/location${endpoint}`, {
            method: 'get',
            credentials: 'same-origin'
        });
        json = await response.json();
    }
    catch (error) {
        throw new ApiError({
            code: 0,
            message: 'api does not respond',
            details: {
                endpoint
            }
        });
    }
    const { error, ...rest } = camelizeKeys(json);
    if (error) {
        throw new ApiError({
            code: 0,
            message: error,
            details: {
                endpoint
            }
        });
    }
    return rest;
};
